import React from 'react'
import InfoBlock from '../../components/InfoBlock'
import _ from 'lodash';

const InfoBlocks = ({ entity }) => {

  const blocks = _.get(entity, 'fieldItems', []).map(item => {
    let setUrl = '';
    let extraClassName = '';

    if (item.entity.fieldMoreLink) {
      setUrl = item.entity.fieldMoreLink.url.path;
    }

    if (item.entity.fieldClassName) {
      extraClassName = item.entity.fieldClassName;
    }

    return {
      icon: _.get(item, 'entity.fieldIcon.entity.fieldMediaIcon.entity.uri.url'),
      title: item.entity.fieldTitle,
      text: item.entity.fieldText,
      url: setUrl,
      moreLinkLabel: _.get(item, 'entity.fieldMoreLink.title'),
      linkLabel: _.get(item, 'entity.fieldMoreLinkLabel', null),
      extraClassName: extraClassName,
    }
  })
  const layout = entity.fieldInfoHalfSize ? 'half-size' : 'full-size';

  return (
    <InfoBlock
      title={entity.fieldTitle}
      smalltext={entity.fieldSmallText}
      text={entity.fieldText}
      blocks={blocks}
      layout={layout}
    />
  )
}

export default InfoBlocks
